import init from './init';
import update from './update';

export const buyBoxMetaActions = {
  init,
  update
};

export type BuyBoxMetaActions = typeof buyBoxMetaActions;
